import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Navlink from '../../Components/Navlink/Navlink';
import links from "./links.js";

import building from "../../icons/building.svg";
import logo from "../../images/logo.svg";
import styles from './navbar.module.css';

export default function NavBar() {
  const location = useLocation();
  const [url, setUrl] = useState(location.pathname)

  useEffect(() => {
    setUrl(location.pathname)
  }, [location]);

  return (
    <div className={styles.container}>
      <div className={styles.navbar}>
        <img src={logo} width="230px" height="32px" style={{ marginBottom: 24 }}/>
        {links.map((x) =>
          <Navlink href={x.path} bgColor={url === x.path ? "#EAECF0" : "#fff"} text={x.title} icon={x.iconUrl}/>
        )}
      </div>
      <div className={styles.outlet}>
        <Outlet/>
      </div>
    </div>
  );
}
